import { SEARCH_PAGE } from "../../state/modules/page/constants";
import { buildQueryByFacets } from "../../helpers/url";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getLocation } from "../../state/modules/router/selectors";
import {
  getAdditionalQueryParams,
  getVisibleFacets,
} from "../../state/modules/search";
import { getPageName } from "../../state/modules/page/selectors";
import {
  getNextPriceRange,
  isCurrentPriceRangeSelected,
} from "../../state/modules/search/domains/priceRange/selectors";

export const useUpdateRefineParameters = ({ searchTerm }) => {
  const location = useSelector(getLocation);
  const additionalQueryParams = useSelector(getAdditionalQueryParams);
  const facets = useSelector(getVisibleFacets);
  const pageName = useSelector(getPageName);
  const nextPriceRange = useSelector(getNextPriceRange);
  const currentPriceRangeSelected = useSelector(isCurrentPriceRangeSelected);

  // eslint-disable-next-line complexity
  useEffect(() => {
    const history = require("../../client/history").default;
    const { query, pathname, hash, state } = location;
    const queryParams = Object.keys(query);

    if (
      pageName === SEARCH_PAGE &&
      !!additionalQueryParams &&
      queryParams?.length === 1 &&
      queryParams[0] === "q"
    ) {
      const additionalRefineParameters =
        buildQueryByFacets(facets, {
          ...nextPriceRange,
          hasSelectedValues: currentPriceRangeSelected,
        }) || additionalQueryParams?.refine;

      if (additionalRefineParameters) {
        const searchParams = new URLSearchParams(location.search || "");

        searchParams.set("refine", additionalRefineParameters);
        history.replace({
          pathname,
          search: `?${searchParams.toString()}`,
          hash,
          state,
        });
      }
    }
  }, [searchTerm]);
};
